import { Injectable } from '@angular/core';
import { Observable } from 'ng2-fancy-image-uploader/node_modules/rxjs/Observable';

@Injectable()
export class GetItemService {

  constructor() { }

  public receivedData;
  public itemset_name;
  public orgRoles;
  getResponse(data,itemset_name){
    this.receivedData = data;
    this.itemset_name = itemset_name;
  }

  sendResponse():Observable<any>{
    return this.receivedData;
  }

  sendItemsetDet():Observable<any>{
    return this.itemset_name;
  }

  getOrganisationRoles(data){
    this.orgRoles = data;
    }
    
    sendOrganisationRoles(){
    return this.orgRoles;
    }


}



// WEBPACK FOOTER //
// ./src/app/get-item.service.ts